import { Response } from '../helper/models';

export class LoginResponse extends Response {
  constructor(httpResponse) {
    super();
    this.originalResponse = httpResponse || {};
    this.authenticated = false;
  }
}
